import {
  Grid,
  Typography,
} from "@material-ui/core";
import React, { ReactElement } from "react";

import { useAppSelector } from "../../../app/hooks";
import LineChart from "../../../features/chart/LineChart";
import { selectDate } from "../../../features/konfiguration/konfigurationSlice";
import { LineChartData } from "../../../features/chart/chartTypes";



export default function TrendsGraph(props: {
  trendsGraphItemProp: LineChartData, chartID: string, layout: string, 
}): ReactElement {

  const trendsGraphItemObject = props.trendsGraphItemProp;
 
  const isUTC = useAppSelector(selectDate);




  return (
        <Grid item xs={props.layout == "double" ? 6 : 12} style={{ textAlign: "center", paddingRight: "20px", paddingTop: "20px" }}>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <Typography >
                {trendsGraphItemObject.title}
              </Typography>
            </Grid>
          </Grid>
          <div>
            {LineChart(trendsGraphItemObject, isUTC, props.chartID)}
          </div>
        </Grid>
  );
}
